module.exports = {"id":"dp2_4l1q5","text":"Collaborating through Digital Technologies","instructions":"Why is clear communication important in digital collaboration?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_4l1q5-a1","text":"To avoid confusion and errors","score":1.8},{"id":"dp2_4l1q5-a2","text":"To reduce internet usage","score":0},{"id":"dp2_4l1q5-a3","text":"To limit team interaction","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.4"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.4/l1q5.json
// module id = 1049
// module chunks = 41